export const LOCAL_STORAGE_CARD_VIEW = 'cardView';
